export class LotCodeDropDown{
    lotCodeOpsId?:number;
    lotNumber:string;
    subLotNumber?:string;
    mainPlantId?:number;
    concatLotNum?:string;
    plantLotNumber?:string;
    year?:number;
    prodInvId?:number


    /**
     * 
     * @param lotCodeOpsId 
     * @param lotNumber 
     */
    constructor(lotNumber:string, subLotNumber?:string, lotCodeOpsId?:number,mainPlantId?:number,concatLotNum?:string,plantLotNumber?:string,year?:number,prodInvId?:number){
        this.lotCodeOpsId = lotCodeOpsId;
        this.lotNumber = lotNumber;
        this.subLotNumber = subLotNumber;
        this.mainPlantId = mainPlantId;
        this.concatLotNum = concatLotNum ;
        this.plantLotNumber = plantLotNumber ;
        this.year = year
        this.prodInvId=prodInvId
    }
}